<script setup lang="ts">
import { onMounted, ref } from 'vue'

const isMounted = ref(false)

onMounted((): void => {
    isMounted.value = true
})
</script>

<template>
    <div>
        <!-- Solves the hydration issue -->
        <Transition
            v-if="isMounted"
            name="fade"
            mode="out-in"
        >
            <slot />
        </Transition>
        <template v-else>
            <slot />
        </template>
    </div>
</template>

<style scoped>
.fade-enter-active,.fade-leave-active{transition:opacity .5s ease-in-out}.fade-enter-from,.fade-leave-to{opacity:0}.fade-enter-to,.fade-leave-from{opacity:1}
</style>
